/**
 * Paginile care se deseneaza FARA schelet - fara antet, fara bara de module,
 * fara alegator de firma.
 *
 * Doua feluri, si amandoua pentru acelasi motiv: ori omul din fata lor nu are
 * cont (tichetul deschis din email), ori nu e niciun om (un televizor pe un
 * perete). In portal erau `staticTemplate` si paginile din
 * `My_Controller::$exceptionsPages`.
 *
 * NU E DOAR O CHESTIUNE DE ASEZARE, si de-aia lista sta intr-un fisier al ei in
 * loc sa fie ingropata in `Shell`: o pagina fara sesiune trebuie sa nu ATINGA
 * nimic din ce cere una. Trei locuri o citesc:
 *
 *  - `Shell` sare desenarea, si stinge `shellQuery` si `todayCountsQuery`. Ele
 *    raspund 401 fara cookie, iar `apiCall` MUTA browserul la ecranul de
 *    intrare cand primeste unul - adica omul ar pleca la „Sign in" inainte
 *    sa-si vada tichetul, iar pe un perete ar scrie „Sign in" pana vine cineva
 *    cu o tastatura.
 *  - `main.tsx` nu porneste ceasul de reinnoire a sesiunii. N-are ce reinnoi -
 *    nu exista sesiune - si pe o tabla de perete ar insemna o cerere catre un
 *    cap autentificat la fiecare atingere a ecranului, luni la rand.
 *  - si oricine mai adauga o pagina de felul asta.
 *
 * Respingerea unei ESCALADARI nu e aici, si dinadins: aceea se face de catre un
 * COLEG cu cont, portalul o tine sub sesiune (nu e in `$exceptionsPages`), si
 * jetonul ei e legat de omul din sesiune. Ea se deschide in aplicatie, cu
 * schelet cu tot.
 *
 * Adresele sunt cele vechi, cuvant cu cuvant, ca legaturile deja trimise sa
 * duca in acelasi loc - de-aia lista se citeste asa cum arata, cu liniuta de
 * jos.
 */
const BARE_PAGES = [
  /* Tabloul pe perete, si afisajul de perete al descoperirii. Al doilea nu are
     sesiune DELOC: cheia e chiar adresa. */
  '/dashboard/wall',
  '/monitor/wallboard/',
  /* Paginile pe care CLIENTUL le deschide din email. */
  '/easeedesk/customer_ticket_details',
  '/easeedesk/reject_planned_ticket',
  '/easeedesk/reopen_resolved_ticket',
  '/easeedesk/ticket_feedback',
  '/easeedesk/ticket/approve/',
  '/easeedesk/ticket/deny/',
  /* Raportul de seara al unui OM, deschis din linkul emailului lui. Omul asta
     de cele mai multe ori nici nu are cont in portal: e un nume de utilizator
     Windows raportat de agent (`it_logged_users_list`). Cheia e chiar jetonul
     din adresa. Segmentul e `my-day`, cuvantul pe care scrisoarea il scrie de
     cand exista (`DayReportEmail::link()`); vezi `router.tsx`. */
  '/productivitee/my-day/',
  /* Confirmarea citirii unei politici IT: angajatul clientului n-are cont, jetonul e cheia. */
  '/easeedesk/policy-ack/',
]

/**
 * Paginile care nu au sesiune DELOC - alea nici nu incearca s-o reinnoiasca.
 *
 * Si paginile deschise din email de cineva fara cont: `main.tsx` cere `/me`
 * si porneste reinnoirea sesiunii pe orice alta pagina, iar un 401 de acolo
 * muta browserul la „Sign in" - linkul Approve din email ducea la intrare in
 * loc de pagina de aprobare (15 octombrie 2026). Jetonul din adresa e cheia.
 */
const SESSIONLESS = [
  '/monitor/wallboard/',
  '/productivitee/my-day/',
  '/easeedesk/customer_ticket_details',
  '/easeedesk/reject_planned_ticket',
  '/easeedesk/reopen_resolved_ticket',
  '/easeedesk/ticket_feedback',
  '/easeedesk/ticket/approve/',
  '/easeedesk/ticket/deny/',
  '/easeedesk/policy-ack/',
]

export function isBarePage(pathname: string): boolean {
  return BARE_PAGES.some((page) => pathname.includes(page))
}

/**
 * Pagina asta n-are nicio sesiune de tinut vie?
 *
 * Deosebita de `isBarePage` fiindca nu sunt acelasi lucru: tabloul de perete
 * (`/dashboard/wall`) n-are schelet, DAR are sesiune si trebuie sa si-o tina.
 * Numai afisajul de descoperire se deschide cu adresa drept cheie.
 */
export function isSessionlessPage(pathname: string): boolean {
  return SESSIONLESS.some((page) => pathname.includes(page))
}
